/*
 * Left-column / right-panel mega menu (Products, etc.).
 *
 * The right-hand submenu panel is shared and pinned to the same spot
 * (see "FULL WIDTH LEFT CATEGORY MEGA MENU" in custom.css) regardless of
 * which category row is hovered. That means reaching it from a row further
 * down the list (e.g. Vibrators) requires the cursor to travel across other
 * rows and empty gaps. Relying on plain CSS :hover for this breaks: as soon
 * as the cursor leaves a row's box, that row's panel hides and the default
 * (first) category reappears before the user can reach the links they want.
 *
 * This keeps the "active" category sticky in JS: it only switches once the
 * user dwells on a new row for a moment (so a quick diagonal swipe across
 * other rows on the way to the panel doesn't steal focus), and only resets
 * to the default row once the pointer leaves the whole menu.
 */
(function () {
  var HOVER_INTENT_DELAY = 150;
  var LIST_SELECTOR = '.header_menu .mega-menu:not(.mega-menu--dropdown) .mega-menu__list';

  function setUpList(list) {
    var items = Array.prototype.filter.call(list.children, function (el) {
      return el.tagName === 'LI';
    });
    if (!items.length) return;

    var activeItem = items[0];
    var switchTimeout;

    function setActive(item) {
      if (item === activeItem) return;
      activeItem = item;
      items.forEach(function (li) {
        li.classList.toggle('is-active-category', li === item);
      });
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(switchTimeout);
        switchTimeout = setTimeout(function () {
          setActive(item);
        }, HOVER_INTENT_DELAY);
      });
    });

    list.addEventListener('mouseleave', function () {
      clearTimeout(switchTimeout);
      setActive(items[0]);
    });
  }

  document.querySelectorAll(LIST_SELECTOR).forEach(setUpList);
})();
